import Avatar from '@mui/material/Avatar';
import { Link } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';
import Typography from '@mui/material/Typography';
import moment from 'moment';

const LocationTile = (props) => {
  const {determineActiveMeal, upcomingMeals, name, logoUrl, formalName, lineLength, listItemIndex, listItemTotal} = props;
  const activeMeal = determineActiveMeal(upcomingMeals);
  let dateURL = moment().format("YYYY/M/D");
  return <Link 
    className={'menus__home-content--link'} 
    style={{ textDecoration: "none", position: 'relative' }} 
    to={"/" + name + "/" + dateURL + "/"}
    role="listitem"
    aria-setsize={listItemTotal || -1}
    aria-posinset={listItemIndex || -1}
    aria-label={`${formalName} - ${activeMeal.meal}${activeMeal.time}${activeMeal.day}`}
  >
    <ListItem className={'menus__home-content--' + activeMeal.status} alignItems="flex-start">
      <ListItemAvatar className={'menus__home-content__status--' + activeMeal.status}>
        <Avatar style={{ borderRadius: 0 }} className={'menus__home-content__status-avatar'} alt={formalName} src={logoUrl} />
      </ListItemAvatar>
      <ListItemText
        primary={formalName}
        secondary={
          <React.Fragment>
            <Typography
              component="span"
              variant="body2"
              color="textPrimary"
              className="menus__home-content__status-text"
            >
              {activeMeal.meal + activeMeal.time + activeMeal.day}
                </Typography>
            <br/>
                <Typography
                    component="span"
                    variant="body2"
                    color="textPrimary"
                >
                    {lineLength}
                </Typography>
          </React.Fragment>
        }
      />
    </ListItem>
  </Link>
  
}

export default LocationTile;